import { fork, all } from 'redux-saga/effects';
import leadSaga from './Leads/sagas';
import projectsSaga from './Projects/sagas';
import appSaga from './App/sagas';
import leadSettingsSaga from './Settings/Leads/sagas';
import projectSettingsSaga from './Settings/Projects/sagas';
import notesSaga from './ProjectTools/Notes/sagas';
import noteSaga from './ProjectTools/Notes/Note/sagas';
import projectSaga from './ProjectTools/Project/sagas';
import billingSagas from './Billing/sagas';

export default function* rootSaga() {
  yield all([
    fork(appSaga),
    fork(projectsSaga),
    fork(leadSaga),
    fork(leadSettingsSaga),
    fork(notesSaga),
    fork(noteSaga),
    fork(projectSaga),
    fork(projectSettingsSaga),
    fork(billingSagas),
  ]);
}
